// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YXQe","clinicsSelect":"styles_clinicsSelect__38Ysp"};